import { getControllerApiVersion } from './utils';

export const co2FanSettingKeys = ['ec', 'ac'].flatMap((kind) =>
  ['exhaust', 'intake'].flatMap((fan) =>
    ['max', 'min'].map((limit) => `${fan}_fan_${kind}_${limit}_co2`)
  )
);

export function supportsCo2SettingsRelocation(controller) {
  return [5052, 5053, 5055, 5155].includes(controller?.type) &&
    getControllerApiVersion(controller) >= 'BAIC';
}

export function co2TemperatureSettings(controller, parent) {
  const category = supportsCo2SettingsRelocation(controller) ? 'climate' : 'co2';
  return {
    readable: controller.access_rights?.[category]?.read === true,
    value: parent.settings[category]?.temp_sp_co2
  };
}

// Legacy API aliases remain in readback for older clients. The current CO2
// editor must never resubmit stale copies owned by Climate/Ventilation.
export function co2SettingsForSubmission(controller, settings) {
  if (!supportsCo2SettingsRelocation(controller)) return settings;
  const result = { ...settings };
  delete result.temp_sp_co2;
  co2FanSettingKeys.forEach((key) => delete result[key]);
  return result;
}

export function migrateCo2SettingsDraft(controller, parent) {
  const legacy = parent.temp_settings?.co2;
  if (!legacy || !supportsCo2SettingsRelocation(controller)) return false;
  let changed = false;
  const move = (key, category) => {
    if (!Object.prototype.hasOwnProperty.call(legacy, key)) return;
    parent.temp_settings[category] ??= {};
    // Read the installed Valtio proxy before mutating the new destination.
    const destination = parent.temp_settings[category];
    // A newer edit already made in the destination wins over the old draft.
    if (!Object.prototype.hasOwnProperty.call(destination, key)) destination[key] = legacy[key];
    delete legacy[key];
    changed = true;
  };
  move('temp_sp_co2', 'climate');
  co2FanSettingKeys.forEach((key) => move(key, 'ventilation'));
  if (!Object.keys(legacy).length) delete parent.temp_settings.co2;
  return changed;
}
